module.exports = __webpack_public_path__ + "MY.png?48c1a0cbd6a4e804a3daa7c64cf35ec3";